import Public_Appointment_signalr from "@/components/public/BookAnAppointment/constants/public_appointment-signalr-constants";

const PublicHub = [
  { ...Public_Appointment_signalr },
];

export default PublicHub;
